module.exports = __webpack_public_path__ + "img/Logo-Websait-color-horizontal.a4343261.png";